// extracted by mini-css-extract-plugin
export var buttonContainer = "_7s-1";
export var fontSizeSelect = "_7s-3";
export var formatSelect = "_7s-2";
export var formats = "_7s-4";
export var hidden = "_7s-5";
export var icon = "_7s-6";
export var select = "_7s-0";